import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import "./PromptModal.css";
import IoClose from "../../../../../assets/images/IoClose.svg";
import TabComponent from "../../Tabs/Tab/TabComponent";
import buildun from "../../../../../assets/images/buildun.svg";
import patternun from "../../../../../assets/images/patternun.svg";
import eye from "../../../../../assets/images/eye.svg";
import Eyeunselect from "../../../../../assets/images/eyeun.svg";
import patternicon from "../../../../../assets/images/pattern.svg";
import build from "../../../../../assets/images/build.svg";
import OverView from "../../../../../pages/Prompt/OverView";
import PrimaryThemes from "../../../../../pages/Prompt/PrimaryThemes";
import Output from "../../../../../pages/Prompt/Output";
import { closePromptModal } from "../../../../../features/Modal/ModalSlice";
import { PROMPT_MODAL_TABS, PROMPT_MODAL_LABELS } from "../../../../../constants/constant";

const PromptModal = ({ promptId, promptData }) => {
  const dispatch = useDispatch();
  const { open } = useSelector((state) => state?.ModalSlice);
  const promptDataRedux = useSelector((state) => state?.ModalSlice?.promptData);
  const [promptDetails, setPromptDetails] = useState(null);
  const [selectedTab, setSelectedTab] = useState(PROMPT_MODAL_TABS.OVERVIEW);

  const verticalIcons = [
    { default: patternun, selected: patternicon },
    { default: buildun, selected: build },
    { default: eye, selected: Eyeunselect },
  ];
console.log(promptId)
  useEffect(() => {
    const currentPromptData = promptData?.data;
    setPromptDetails(promptData ? currentPromptData : promptDataRedux?.data);
  }, [promptData, promptDataRedux]);

  const handleTabChange = (tabName) => {
    setSelectedTab(tabName);
  };

  const handleCloseModal = () => {
    dispatch(closePromptModal());
  };

  const renderTabContent = () => {
    const tabContent = {
      [PROMPT_MODAL_TABS.OVERVIEW]: (
        <OverView
          purpose={promptDetails?.purpose}
          role={promptDetails?.role}
          goal={promptDetails?.goal}
        />
      ),
      [PROMPT_MODAL_TABS.PRIMARY_THEMES]: (
        <PrimaryThemes
          primaryData={promptDetails?.project_prompt_theme_relation}
          promptId={promptId}
        />
      ),
      [PROMPT_MODAL_TABS.OUTPUT_INSTRUCTIONS]: (
        <Output outputdata={promptDetails?.output_data} />
      )
    };

    return tabContent[selectedTab] || null;
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="prompt-modal-title"
      aria-describedby="prompt-modal-description"
    >
      <Box className="PromptModal" onClick={(e) => e.stopPropagation()}>
        <Button
          className="closeModalBtn sizeLarge"
          onClick={handleCloseModal}
        >
          <img width="24px" height="24px" src={IoClose} alt="close" />
        </Button>
        
        <div className="file_header">
          <div className="attach">{promptDetails?.name}</div>
          <div className="header_right d-flex align-items-baseline gap-3" />
        </div>

        <div className="w-100 modal-content-body d-flex flex-column justify-content-center">
          <div className="prompt-content">
            <div className="promptmaincontainer">
              <div className="promptleftsidecontainer">
                <TabComponent
                  orientation="vertical"
                  labels={PROMPT_MODAL_LABELS}
                  icons={verticalIcons}
                  onTabChange={handleTabChange}
                  selectedTab={selectedTab}
                />
              </div>
              <div className="prompt-modal-divider" />
              <div className="promptrightsidecontainer">
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default PromptModal;
